var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"contact"}},[_c('h4',{staticStyle:{"color":"#666"}},[_vm._v("Contact Us")]),_c('button',{staticClass:"submit-button",on:{"click":_vm.mailTo}},[_vm._v(" Send Message "),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])
}]

export { render, staticRenderFns }